<template>
  <svg
    role="img"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 -960 960 960"
    class="icon-copy"
  >
    <path
      fill="currentColor"
      d="M105.87-236.61v-79.78h79.22v79.78h-79.22Zm0-171.3v-79.79h79.22v79.79h-79.22Zm0-171.31v-79.22h79.22v79.22h-79.22ZM276.61-65.87v-79.22h79.78v79.22h-79.78Zm79.78-170.74q-32.74 0-56.26-23.52-23.52-23.52-23.52-56.26v-498.52q0-32.74 23.52-56.26 23.52-23.53 56.26-23.53h378.52q32.74 0 56.26 23.53 23.53 23.52 23.53 56.26v498.52q0 32.74-23.53 56.26-23.52 23.52-56.26 23.52H356.39Zm0-79.78h378.52v-498.52H356.39v498.52Zm91.52 250.52v-79.22h79.22v79.22h-79.22Zm-262.82 0q-33.26 0-56.24-22.98-22.98-22.98-22.98-56.24h79.22v79.22Zm433.56 0v-79.22h79.79q0 33.48-23.15 56.35-23.15 22.87-56.64 22.87ZM105.87-749.96q0-33.49 22.98-56.63 22.98-23.15 56.24-23.15v79.78h-79.22Zm439.78 184.31Z"
    />
  </svg>
</template>
